import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/constants/queryKeys';
import { clientsApi } from '../api/clients.api';
import type { ClientFilters } from '../types/client.types';

export function useClients(filters: ClientFilters) {
  return useQuery({
    queryKey: queryKeys.clients.list(filters),
    queryFn: () => clientsApi.getAll(filters),
  });
}

export function useClient(id: number | string | undefined) {
  return useQuery({
    queryKey: queryKeys.clients.detail(id ?? ''),
    queryFn: () => clientsApi.getById(id!),
    enabled: !!id,
  });
}
